<template>
  <div class="agent-grid-page" dir="rtl">
    <div class="agent-grid">
      <div v-for="agent in agents" :key="agent.id" class="agent-card" :class="'status-' + agent.status">
        <div class="agent-card-top">
          <div class="ring-wrap">
            <v-icon v-if="agent.status == 'offline'" color="gray" size="24" class="iconStyle">
              mdi-phone-off
            </v-icon>
            <v-icon v-else-if="agent.status == 'ring'" color="#ebc325" size="24" class="iconStyle">
              mdi-phone-ring
            </v-icon>
            <v-icon v-else-if="agent.status == 'onCall'" color="#2563eb" size="24" class="iconStyle">
              mdi-phone-incoming-outgoing
            </v-icon>
            <v-icon v-else-if="agent.status == 'dnd'" color="#696969" size="24" class="iconStyle">
              mdi-phone-paused
            </v-icon>
            <v-icon v-else-if="agent.status == 'available'" color="var(--v-success-base)" size="24" class="iconStyle">
              mdi-phone-hangup
            </v-icon>
          </div>

          <div class="agent-meta">
            <span class="agent-name">{{ agent.name }}</span>
            <span class="status-pill" :class="'pill-' + agent.status">
              <span class="status-dot"></span>
              {{ statusLabel(agent.status) }}
            </span>
          </div>
        </div>

        <div class="agent-card-stats">
          <div class="stat stat-answered">
            <v-icon size="16" color="#16A34A">mdi-phone-check-outline</v-icon>
            <span class="stat-num" v-if="agent.status !== 'offline'">{{ agent.answeredCount }}</span>
            <span class="stat-label">پاسخ داده</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat stat-missed">
            <v-icon size="16" color="#D97706">mdi-phone-alert-outline</v-icon>
            <span class="stat-num" v-if="agent.status !== 'offline'">{{ agent.missedCount }}</span>
            <span class="stat-label">بدون پاسخ </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentStatusGrid',
  props: {
    // { id, extension, name, status: 'onCall' | 'available' | 'offline', answeredCount, missedCount }
    agents: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    statusLabel(status) {
      return {
        onCall: 'در حال مکالمه',
        available: 'آماده / بدون تماس',
        offline: 'غیرفعال',
        dnd: 'DND',
        ring: 'در حال تماس',
      }[status] || '---';
    },
  },
};
</script>

<style scoped>
.agent-grid-page {
  background: #ffffff;
  /* padding: 24px; */
  border-radius: 16px;
  width: 100%;
}

.agent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 14px;
}

.agent-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0px 1px 7px 0px rgba(15, 23, 42, 0.04), 0 1px 8px rgba(15, 23, 42, 0.06);
  border: 1px solid #eef1f5;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.agent-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
}

.agent-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ring-wrap {
  position: relative;
  /* width: 56px;
  height: 56px; */
  flex-shrink: 0;
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  box-shadow: 0px 5px 15px -5px var(--v-secondary-base)
}

.ring-svg {
  width: 56px;
  height: 56px;
  transform: rotate(-90deg);
}

.ring-track {
  fill: none;
  stroke: #eef1f5;
  stroke-width: 5;
}

.ring-fill {
  fill: none;
  stroke-width: 5;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.6s ease, stroke 0.3s ease;
}

.ring-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ring-id {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.agent-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.agent-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  width: fit-content;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.pill-onCall {
  background: #eaf1ff;
  color: #2563eb;
}

.pill-onCall .status-dot {
  background: #2563eb;
  animation: pulse-dot 1.4s infinite;
}

.pill-available {
  background: #eafaf0;
  color: #16a34a;
}

.pill-available .status-dot {
  background: #16a34a;
}

.pill-offline {
  background: #f1f3f6;
  color: #94a3b8;
}

.pill-offline .status-dot {
  background: #94a3b8;
}

.pill-dnd {
  background: #eaeaea;
  color: #4c4c4c;
}

.pill-dnd .status-dot {
  background: #4c4c4c;
}

.pill-ring {
  background: #efefe6;
  color: #827300;
}

.pill-ring .status-dot {
  background: #b8b694;
}

@keyframes pulse-dot {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.5);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(37, 99, 235, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
  }
}

.agent-card-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #eef1f5;
}

.stat {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-num {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.stat-label {
  font-size: 11px;
  color: #94a3b8;
}

.stat-divider {
  width: 1px;
  height: 20px;
  background: #eef1f5;
}

.agent-card.status-onCall {
  border-right: 4px solid #2563eb;
  background: #f4f8ff;
}

.agent-card.status-available {
  border-right: 4px solid #16a34a;
  background: #f5fff9;
}

.agent-card.status-offline {
  border-right: 4px solid #ececec;
  opacity: 0.4;
}

.agent-card.status-dnd {
  border-right: 4px solid #696969;
  background: #d9d9d9;
}

.agent-card.status-ring {
  border-right: 4px solid #ebc325;
  background: #fffcf1;
}
</style>
